import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// ClientSystems Redux States
import {
  GET_CLIENT_SYSTEM_VALUES,
  GET_CLIENT_SYSTEM_VALUE,
  CREATE_CLIENT_SYSTEM_VALUE,
  DELETE_CLIENT_SYSTEM_VALUE,
  EDIT_CLIENT_SYSTEM_VALUE,
} from "./actionTypes";
import {
  setClientSystems,
  apiError,
  setClientSystem,
  createClientSystemSuccess,
  editClientSystemSuccess,
  deleteClientSystemSuccess,
} from "./actions";

//Include Both Helper File with needed methods
import axios from "axios";

function* getClientSystems({
  payload: { idCompany, page, qnt, clientId, variable, value, isForm },
}) {
  try {
    const response = yield call(
      axios.get,
        `/client-system?${
          (idCompany ? `&client_id=${idCompany}` : "") +
          (page ? `&page=${page}` : "") +
          (qnt ? `&qtd=${qnt}` : "") +
          (clientId ? `&client_id=${clientId}` : "") +
          (variable ? `&variable=${variable}` : "") +
          (value ? `&value=${value}` : "") +
          (isForm ? `&form=${isForm}` : "")
        }`
      
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response?.data?.data
    ) {
      yield put(setClientSystems(response?.data?.data, qnt, idCompany));
    } else throw response.data;
  } catch (error) {
    let message = error.message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          //TODO: remover esta verificação quando o backend enviar array vazio com status 200 quando nao ha objetos
          if (error.response.data && typeof error.response.data === "object") {
            message = error.response.data.message;
          } else {
            message = "Sorry! the page you are looking for could not be found";
          }
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

function* createClientSystem({
  payload: { newClientSystemValues, idCompany, idDepartment },
}) {
  try {
    let response = yield call(
      axios.post,
      `/client-system`,
      newClientSystemValues
    );

    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.message
    ) {
      let message = response.data.message;
      yield put(createClientSystemSuccess(message));
    } else {
      throw response.data;
    }
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

function* getClientSystem({ payload: { idClientSystem, idCompany, isForm } }) {
  try {
    let response = yield call(
      axios.get,
      `/client-system?${
        (idCompany ? `&client_id=${idCompany}` : "") +
        (idClientSystem ? `&id=${idClientSystem}` : "") +
        (isForm ? `&form=${isForm}` : "")
      }`,
      {}
    );

    if ((response.status >= 200 || response.status <= 299) && response.data) {
      yield put(setClientSystem(response.data));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
function* editClientSystem({
  payload: { idClientSystem, newClientSystemValues, idCompany },
}) {
  try {
    let response = yield call(
      axios.patch,
      `/client-system?${
        (idCompany ? `&client_id=${idCompany}` : "") +
        (idClientSystem ? `&id=${idClientSystem}` : "")
      }`,
      newClientSystemValues
    );

    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.message
    ) {
      let message = response.data.message;
      yield put(editClientSystemSuccess(message));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
function* deleteClientSystem({ payload: { idClientSystem, idCompany } }) {
  try {
    let response = yield call(
      axios.delete,
      `/client-system?${
        (idCompany ? `&client_id=${idCompany}` : "") +
        (idClientSystem ? `&id=${idClientSystem}` : "")
      }`,
      {}
    );

    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.message
    ) {
      let message = response?.data?.message ?? "";
      yield put(deleteClientSystemSuccess(message));
    } else {
      throw response.data;
    }
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

export function* watchClientSystemsClient() {
  yield takeEvery(GET_CLIENT_SYSTEM_VALUES, getClientSystems);
}
export function* watchGetClientSystem() {
  yield takeEvery(GET_CLIENT_SYSTEM_VALUE, getClientSystem);
}
export function* watchCreateClientSystem() {
  yield takeEvery(CREATE_CLIENT_SYSTEM_VALUE, createClientSystem);
}
export function* watchEditClientSystem() {
  yield takeEvery(EDIT_CLIENT_SYSTEM_VALUE, editClientSystem);
}
export function* watchDeleteClientSystem() {
  yield takeEvery(DELETE_CLIENT_SYSTEM_VALUE, deleteClientSystem);
}
function* authSaga() {
  yield all([
    fork(watchClientSystemsClient),
    fork(watchCreateClientSystem),
    fork(watchGetClientSystem),
    fork(watchEditClientSystem),
    fork(watchDeleteClientSystem),
  ]);
}

export default authSaga;
